import { render, staticRenderFns } from "./BlendDetail.vue?vue&type=template&id=05526c2c"
import script from "./BlendDetail.vue?vue&type=script&lang=js"
export * from "./BlendDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports